import { getReactionSummary } from "../../helpers/reactionsHelper";

export const ReactionSummary = ({
  reactionsData = null,
  availableReactions = [],
}) => {
  if (!reactionsData) return null;

  const reactionSummary = getReactionSummary(reactionsData);

  // Filter out reactions with count 0 and sort by count (descending)
  const activeReactions = reactionSummary
    .filter((r) => r.count > 0)
    .sort((a, b) => b.count - a.count);

  if (activeReactions.length === 0) return null;

  return (
    <div
      className="d-flex align-items-center"
      style={{
        gap: "8px",
        // marginTop: "16px",
        // marginBottom: "4px",
        flexWrap: "wrap",
      }}
    >
      {activeReactions.map((reaction) => (
        <div
          key={reaction.reaction_type_id || reaction.id}
          className="d-flex align-items-center justify-content-center"
          style={{
            gap: "6px",
            padding: "6px 10px",
            backgroundColor: "rgba(42, 64, 82, 0.5)",
            border: "1px solid #008CFF",
            borderRadius: "16px",
          }}
        >
          <span
            style={{
              color: "#D0D8DF",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "1",
              marginRight: "4px",
            }}
          >
            {reaction.count}
          </span>
          <span style={{ fontSize: "14px", lineHeight: "1" }}>
            {reaction.emoji}
          </span>
        </div>
      ))}
    </div>
  );
};
